module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcElEQVR42u3QMREAMAwDsVAsqsJ2SaSTlbvfY02Saa56PAAAAAAAAAAAAAAAycw92Wz7PvwHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1AC0BgAAAAAAAAAAAABAaQ/CKcHmaqcL0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Nigeria.png
// module id = trAH
// module chunks = 0 62 63